const REMEMBER_EMAIL_KEY = 'munidados_remembered_email';

export const saveRememberedEmail = (email: string): void => {
    try {
        localStorage.setItem(REMEMBER_EMAIL_KEY, email);
    } catch (error) {
        console.warn('Failed to save remembered email:', error);
    }
};

export const getRememberedEmail = (): string | null => {
    try {
        return localStorage.getItem(REMEMBER_EMAIL_KEY);
    } catch (error) {
        console.warn('Failed to retrieve remembered email:', error);
        return null;
    }
};

export const clearRememberedEmail = (): void => {
    try {
        localStorage.removeItem(REMEMBER_EMAIL_KEY);
    } catch (error) {
        console.warn('Failed to clear remembered email:', error);
    }
};